/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { NotificationsEvidenceExportCompletedNotificationDataDto } from "./NotificationsEvidenceExportCompletedNotificationDataDto";

export const NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnum = {
    "audit-reports_evidence-export-completed": "audit-reports_evidence-export-completed"
} as const;

export type NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnumKey = (typeof NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnum)[keyof typeof NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnum];

export type NotificationsEvidenceExportCompletedNotificationDto = {
    /**
     * @description Knock workflow key. Map from the feed item source.key; not part of trigger data.
     * @type string
    */
    workflowKey: NotificationsEvidenceExportCompletedNotificationDtoWorkflowKeyEnumKey;
    /**
     * @description In-app notification data for audit-reports_evidence-export-completed
     * @type object
    */
    data: NotificationsEvidenceExportCompletedNotificationDataDto;
};